var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar"),
      _c(
        "div",
        { staticClass: "flex flex-col items-center justify-center mt-10" },
        [
          _c("img", {
            staticClass: "w-18 h-18",
            attrs: {
              src: _vm.filterStatus().icon,
              alt: _vm.filterStatus().text,
            },
          }),
          _c("p", { staticClass: "text-center text-lg mt-4" }, [
            _vm._v(_vm._s(_vm.filterStatus().text)),
          ]),
          _c(
            "div",
            { staticClass: "flex mt-10" },
            [
              _vm.isLoggedIn && _vm.payInfo.status == "00"
                ? _c(
                    "van-button",
                    {
                      staticClass: "w-30 h-9 rounded-xl mr-3",
                      attrs: { type: "primary", color: "#ff7a00" },
                      on: { click: _vm.goOrder },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("pay.goOrderDetail")) + " ")]
                  )
                : _vm._e(),
              _c(
                "van-button",
                {
                  staticClass: "w-30 h-9 rounded-xl",
                  attrs: { type: "primary", color: "#ff7a00" },
                  on: { click: _vm.goHome },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.goHome")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }